// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import dataTableStyles from "@rpsc/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { orderSummaryCardStyles } from "@rpsc/Overrides/Components/OrderSummaryCard";
import IconCartReorderLink from "@rpsc/XDL/Icons/IconCartReorderLink";
import { fontConfig } from "@rpsc/XDL/PreStyle/typography";
import { createLinkIconStyles, ellipsis } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

orderSummaryCardStyles.clickableCell = {
    ...dataTableStyles.clickableCell,
};

orderSummaryCardStyles.reorderLink = {
    ...createLinkIconStyles(IconCartReorderLink, {
        icon: {
            iconProps: {
                css: css`
                    &,
                    svg {
                        height: 13px;
                    }
                `,
            },
        },
    }),
};

orderSummaryCardStyles.reorderLinkSpinner = {
    size: 20,
};

orderSummaryCardStyles.actionsCells = {
    tight: true,
    css: css`
        min-width: 100px;
        ${TypographyStyle} {
            font-size: ${fontConfig.fontSize.xSmall};
            line-height: ${fontConfig.lineHeight.xSmall};
        }
    `,
};

orderSummaryCardStyles.dataCells = {
    tight: true,
};
orderSummaryCardStyles.shipToCells = {
    css: css`
        max-width: 320px;
        min-width: 220px;
        white-space: normal;
        > ${TypographyStyle} {
            ${ellipsis(1)}
        }
    `,
};
